import {FC} from "react";
import CKEditorReadonly from "@/components/CKEditorReadonly.tsx";

interface StepFiveModelProps {
  shredId: string | undefined;
  shredName: string;
  shredDescription: string;
}

const StepFiveModel: FC<StepFiveModelProps> = (props) => {
  const {
    shredName,
    shredDescription,
  } = props;
  
  return (
    <>
      <div className="mb-6">
        <span className="text-xl text-[#6F6AF8] font-medium ml-1">
          Shred Name
        </span>
        <div
          className="border border-gray-300 p-3 flex items-center rounded w-full whitespace-pre-wrap bg-gray-50">
          {shredName}
        </div>
      </div>
      
      <div>
        <span className="text-xl text-[#6F6AF8] font-medium ml-1">
          Shred Description
        </span>
        <div
          className=" border-gray-300 w-full whitespace-pre-wrap transition-max-height"
        >
          <CKEditorReadonly content={shredDescription} showToggleButton={false}/>
        </div>
      </div>
    </>
  );
};

export default StepFiveModel;
